import React from 'react'
import { TableCell } from '@mui/material'
import moment from 'moment'

export function PackagesTableItems({ item }) {
    return (
        <>
            <TableCell>
                {item.appLicensingVerdict ? item.appLicensingVerdict : '-'}
            </TableCell>
            <TableCell>
                {item.appRecognitionVerdict ? item.appRecognitionVerdict : '-'}
            </TableCell>
            <TableCell>
                {item.appVersionCode ? item.appVersionCode : '-'}
            </TableCell>
            <TableCell>
                {item.appVersionName ? item.appVersionName : '-'}
            </TableCell>
            <TableCell>
                {item.attendanceCount ? item.attendanceCount : '-'}
            </TableCell>
            <TableCell>
                {moment(item.createdAt).format('YYYY-MM-DD HH:mm')}
            </TableCell>
            <TableCell>
                {item.deviceId ? item.deviceId : '-'}
            </TableCell>
            <TableCell>
                {item.deviceModel ? item.deviceModel : '-'}
            </TableCell>
            <TableCell>
                {item.deviceName ? item.deviceName : '-'}
            </TableCell>
            <TableCell>
                {item.ipAddress ? item.ipAddress : '-'}
            </TableCell>

        </>
    )
}
